const UserSideMenu = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'user.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-home-4-line'
  },
  {
    title: 'Vouchers',
    is_active: false,
    link: {
      name: 'user.vouchers'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-file-word-2-line'
  }
]

export default UserSideMenu
